module.exports = __webpack_public_path__ + "static/pic09.b598bd94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic09.jpg
// module id = 131
// module chunks = 23718644409033 183886176117593